import {GNWP_SOURCES} from "../../../../components/external_links/external_links_consts";
import USBaseRegulation from "../us/us_base_regulation";
import {REGULATION_CODE_TYPES} from "../../regulation_const";
import BaseComponent from "../../../../base/base_component";
import MichiganResponsibleGamingIconsController
    from "../../../../components/regulation_components/us/michigan/michigan_responsible_gaming_icons_controller";

export default class MichiganRegulation extends USBaseRegulation {
    static CLASS = 'MichiganRegulation';

    protected _getRegulationType(): number {
        return REGULATION_CODE_TYPES.MICHIGAN;
    }

    getResponsibleGamingIconsComponent(params: any): BaseComponent {
        return MichiganResponsibleGamingIconsController.create(params);
    }

    stepsBeforeOpenLoginAndRegistration():Promise<void> {
        return this.serviceFactory.orbitComponentRenderService().showLocationPopup({});
    }

    shouldRefreshTokenOnAppOpen(){
        return true;
    }

    runConditionsBeforeOpenLink(source: string):Promise<void> {
        if(source !== GNWP_SOURCES.MEMBERSHIP) {
            return Promise.resolve();
        }

        return this.stepsBeforeOpenLoginAndRegistration();
    }

    supportWithdrawOnlyFromReal() {
        return true;
    }
}